module.exports = {
  commonBase: {
    wz0: "Tipo de operación",
    wz1: "operación",
    wz2: "Mantenimiento",
    wz3: "Operación direcata de Star Charge",
    wz4: "Franquicia",
    wz5: "Operación conjunta",
    wz6: "Operación de terceros",
    wz7: "Estación eléctrica Renren",
    wz8: "Estaca privada",
    wz9: "Pilotes no privados",
    wz10: "all",
  },
  PowerBoxDetail: {
    title1: "Información básica",
    title2: "Número de módulo de lectura del medidor",
    title3: "Nombre del dispositivo",
    title4: "Atributos de hardware",
    title5: "Modelo de firmware actual",
    title6: "Número de versión actual",
    title7: "Datos del medidor",
    value1: "Corriente de fase A",
    value2: "Voltaje de fase A",
    value3: "Corriente de fase B",
    value4: "Voltaje de fase B",
    value5: "Corriente de fase C",
    value6: "Voltaje de fase C",
    value7: "Capacidad de fase A",
    value8: "Capacidad de fase B",
    value9: "Capacidad de fase C",
    value10: "Potencia de fase A",
    value11: "Potencia de fase B",
    value12: "Potencia de fase C",
    value13: "Potencia total trifásica",
    value14: "Potencia total - Pico",
    value15: "Potencia total - Agudo",
    value16: "Potencia total - Bajo",
    value17: "Potencia total - Hombro",
    value18: "Potencia total trifásica",
    wz1: "Información del firmware",
  },
  powerBoxList: {
    title1: "Número de módulo de lectura del medidor",
    placeholder1: "Ingrese el número del módulo de lectura del medidor",
    placeholder2: "Ingrese el nombre de la estación eléctrica",
    title2: "Nombre de la estación eléctrica",
    btn1: "Indagar",
    title3: "Número de gabinete de distribución",
    title4: "Nombre de la estación eléctrica",
    title5: "Modelo de firmware actual",
    title6: "Número de versión actual",
    title7: "Número de medidor",
    title8: "Potencia nominal",
    action: "Operación",
    title9: "Detalles del gabinete de distribución",
    title10: "Lista de dispositivos",
    title11: "Consulta rápida de equipos",
    title12: "Detalles del gabinete de distribución",
    wz1: "Información del firmware",
    wz2: "Número del medidor",
  },
  configModify: {
    title1: "Campo de configuración (rango de campo)",
    title2: "Lista de dispositivos",
    title3: "Configuración de la plataforma",
    title4: "Detalles del pedido",
  },
  logDetail: {
    title1: "Campo de parámetros",
    title2: "Antes del cambio",
    title3: "Despues del cambio",
  },
  modifyLog: {
    actionSheet: "Tipo de operación",
    btn1: "Modificar",
    btn2: "Enviar sincronización",
    title1: "Método de operación",
    title2: "En línea",
    title3: "Desconectado",
    title4: "Plataforma operativa",
    title5: "Operador",
    title6: "Tiempo de funcionamiento",
    btn3: "Cambiar parámetros",
    btn4: "Vista",
  },
  orderChargeCourse: {
    title1: "Información de final de punto de carga",
    title2: "Información del módulo",
  },
  orderDetailInfo: {
    title1: "Número de pedido comercial",
    title2: "Número de pedido de plataforma",
    title3: "Modelo de vehículo",
    title4: "Número de placa",
    title5: "Código VIN del vehículo",
    title6: "Tiempo de carga",
    title7: "Tiempo de carga real",
    title8: "ID del dispositivo",
    title9: "Duración de carga",
    title10: "Nombre de la estación eléctrica",
    title11: "Capacidad de carga (kW/h)",
    title12: "Estado de cargo",
    state1: "Iniciando",
    state2: "Iniciando",
    state3: "Finalización de carga",
    title13: "Código de desbloqueo",
    title14: "Motivo para detenerse",
  },
  powerMoudleChargeCourse: {
    brand1: "Delta",
    brand2: "Star Charge",
    brand3: "ZTE",
    title1: "Información de falla",
    msg1: "Voltaje",
    msg2: "Corriente",
    msg3: "Tempertura",
    wz1: "Número de pedido",
    wz3: "Sin datos",
  },
  stubChargeCourse: {
    title1: "Voltaje de salida al final del pilote",
    title2: "Voltaje de demanda de terminal del vehículo",
    title3: "Corriente de salida al final del punto de carga",
    title4: "Corriente demanda de vehículo ",
    title5: "Capacidad de eléctrica",
    title6: "Temperatura de la batería",
    title7: "Temperatura final del conector",
    title8: "Temperatura final del punto de carga",
    title9: "Voltaje",
    title10: "Corriente",
    title11: "SOC",
    title12: "Capacidad de eléctrica",
    title13: "Temperatura",
  },
  stubDetailInfo: {
    title1: "Información básica",
    title2: "ID del dispositivo",
    title3: "La estación eléctrica pertenecia",
    title4: "Nombre del dispositivo",
    title5: "Tipo de equipo",
    title6: "Corriente alterna",
    title7: "Corriente continua",
    title8: "CA/CC",
    title9: "Modelo de dispositivo",
    title10: "Estado del dispositivo",
    title11: "Registro de estado",
    title12: "Con o sin conector",
    title13: "Límite superior de voltaje",
    title14: "Límite  inferior de voltaje",
    title15: "Potencia en tiempo real",
    title16: "Potencia máxima",
    title17: "Voltaje auxiliar",
    title18: "Información del software",
    title19: "Versión de firmware",
    title20: "Modelo de firmware",
    title21: "Información de hardware",
    title22: "Número de tarjeta iccid",
    title23: "Registro de estado",
    no: "No",
    yes: "Sí",
    wz1: "Información del firmware",
  },
  stubList: {
    placeholder1: "Ingrese el iD del dispositivo",
    title1: "iD del dispositivo",
    placeholder2: "Ingrese el nombre de la estación eléctrica",
    title2: "Nombre de la estación eléctrica",
    placeholder3: "Ingrese el número del medidor",
    placeholder4: "",
    title3: "Número del medidor",
    title4: "Todos",
    title5: "Corriente alterna",
    title6: "Corriente continua",
    title7: "CA/CC",
    title8: "Seleccione",
    title9: "Tipo de equipo",
    title10: "Seleccione",
    title11: "Modelo de dispositivo",
    title12: "Seleccione",
    title13: "Versión de firmware",
    title14: "Seleccione",
    title15: "Modelo de firmware",
    title16: "Indagar",
    title17: "ID del dispositivo",
    title18: "La estación eléctrica pertenecia",
    title19: "Tipo de equipo",
    title20: "Corriente alterna",
    title21: "Corriente continua",
    title22: "CA/CC",
    title23: "Incógnita",
    title24: "Modelo de dispositivo",
    title25: "Versión de firmware",
    title26: "Modelo de firmware",
    title27: "Estado del dispositivo",
    action: "Operación",
    btn1: "Detalles del equipo",
    btn2: "Modifice estado",
    btn3: "Detalles del equipo",
    btn4: "Información básica",
    btn5: "Información del pedido",
    btn6: "Modificación del estado",
    btn7: "Información de configuración",
    btn8: "Exportar",
    title28: "ID del dispositivo",
    title29: "Indagar",
    title30: "",
    dw: "Día",
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo",
    btn: "Lista de dispositivos",
    wz1: "Ingrese Número de gabinete de distribución ",
    wz2: "número de gabinete de distribución",
    wz3: "Información del firmware",
    wz4: "ID del dispositivo",
    wz5: "Información de configuración",
    wz6: "Información del módulo",
    wz7: "Obtener información del firmware",
    wz8: "Actualización de firmware",
    wz9: "Zona",
  },
  stubOrderInfo: {
    placeholder1: "Seleccione un rango de fechas",
    title1: "Hora de finalización del pedido",
    btn1: "Indagar",
    btn2: "Exportar",
    title2: "Número de pedido de plataforma",
    title3: "Tiempo de carga",
    title4: "Capacidad de eléctrica(kW/h)",
    title5: "Estado de cargo",
    title6: "Iniciando",
    title7: "Cargando",
    title8: "Finalización de carga",
    title9: "Motivo para detenerse",
    action: "Operación",
    btn3: "Detalles del pedido",
    btn4: "Proceso de carga",
    btn5: "Proceso de carga",
    btn6: "Detalles del pedido",
    wz1: "Número de pedido comercial", // 一下机翻
    wz2: "Número de pedido comercial",
    wz3: "Número de pedido de plataforma",
    wz4: "Número de pedido de plataforma",
    wz5: "ID del dispositivo",
    wz6: "ID del dispositivo",
    wz7: "Número de usuario",
    wz8: "Número de usuario",
    wz9: "Canal de carga",
    wz10: "Canal de carga",
    wz11: "Hora de finalización del pedido",
    wz12: "Motivo para detenerse",
    wz13: "Motivo para detenerse",
    wz14: "estación eléctrica",
    wz15: "Zona",
    wz16: "Tiempo de carga real",
    wz17: "Duración de carga",
    wz18: "Datos del dispositivo", // 以下机翻译
    wz19: "Datos de los módulos",
    wz20: "Registro de plataforma",
    wz21: "Registro de plataforma",
  },
  stubParamsConfig: {
    title1: "Campo de configuración (rango de campo)",
    title2: "Configuración del dispositivo",
    title3: "Configuración de la plataforma",
    btn3: "Descargar",
    title4: "Tiempo de cambio de configuración de plataforma",
    title5: "Campo de configuración (rango de campo)",
    title6: "Configuración del dispositivo",
    title7: "Configuración de la plataforma",
    msg1:
      "Puede haber una demora en la obtención de información, puede hacer clic en “Obtener configuración del dispositivo” para verificar la información más reciente",
    msg2: "Operación exitosa",
    msg3: "Sin modificación de datos, haga clic en Cancelar para cerrar la ventana",
    msg4: "Comando emitido con éxito",
    title8: "ID del dispositivo",
    title9: "Nombre de la estación eléctrica",
    title10: "Código de verificación de configuración del dispositivo",
    title11: "Tiempo de cambio de configuración del dispositivo",
    title12: "Tiempo de informe del dispositivo",
    title13: "Código de verificación de configuración final de plataforma",
    title14: "Tiempo de entrega de la configuración del lado de la plataforma",
    title15: "Última hora modificada en la plataforma",
    title16: "Plantilla de configuración",
    title17: "Obtener configuración del lado del dispositivo",
    title18: "Modificar la configuración de la plataforma",
    title19: "Usar configuración de plataforma",
    title20: "Usar configuración del dispositivo",
    title21: "registro de cambios",
    title22: "Actualización de datos",
    btn1: "Cancelar",
    btn2: "Guardar",
    wz1: "Información de configuración",
  },
  stubStatusLog: {
    title1: "Selección de mes",
    btn1: "Indagar",
    btn2: "Exportar",
    title2: "Tiempo de informe",
    title3: "Código de estado",
    title4: "Información de estado",
  },
  stubStatusUpdate: {
    msg1: "Operación exitosa",
    msg2_1: "La longitud del contenido debe estar entre",
    msg2_2: "y",
    msg2_3: "",
    title1: "Modificar estado",
    placeholder1: "Seleccione un estado para editar",
    placeholder2: "Seleccione",
    state1: "En mantenimiento",
    state2: "Desconectado",
    title2: "Razón para el cambio",
    placeholder3: "Interese el motivo del cambio",
    btn1: "Confirmar",
  },
  stubGroupList: {
    placeholder1: "Seleccione Zona",
    title1: "Zona",
    title2: "Nombre de la estación eléctrica",
    btn1: "Indagar",
    title3: "Número de punto de carga de CC",
    title4: "Número de punto de carga de CA",
    title5: "Zona de la estación eléctrica",
    action: "Operación",
    btn2: "Lista de dispositivos",
    btn3: "Consulta rápida de equipos",
    btn4: "Lista de gabinetes de distribución",
    btn5: "Gestión de gabinete de distribución",
    all: "Todos",
  },
  appkeySuccessRate: {
    title1: "Rango",
    title2: "Canal",
    title3: "Pedidos totales",
    title4: "Número de pedidos fallidos",
    title5: "Tasa de éxito",
    tool1: "Tasa de éxito = pedido de carga exitosa / pedido de carga total",
    btn1: "Lista de orden",
    wz1: "Detalles del pedido",
  },
  chargeOrderDetail: {
    btn1: "Exportar",
    title1: "Número de pedido",
    title2: "ID del dispositivo",
    title3: "Tiempo de carga",
    title4: "Número de usuario",
    title5: "Capacidad de eléctrica",
    title6: "Código VIN del vehículo",
    title7: "Modelo de vehículo",
    title8: "Canal de carga",
    title9: "Motivo para detenerse",
    action: "Operación",
    btn2: "Proceso de carga",
  },
  chargSuccess: {
    placeholder1: "Seleccione un rango de fechas",
    title1: "Fecha",
    placeholder2: "Seleccione la Zona",
    title2: "Zona",
    operationMode1: "Todos",
    operationMode2: "Operación de terceros",
    operationMode3: "Operación conjunta",
    operationMode4: "Operación directa Star Charge",
    operationMode5: "Operación franquicia",
    operationMode6: "Interconexión",
    operationMode7: "Estación eléctrica Renren",
    placeholder3: "Seleccione",
    title3: "Tipo de operación",
    all: "Todos",
    type1: "Corriente alterna",
    type2: "Corriente continua",
    placeholder4: "Seleccione",
    title4: "Tipo de equipo",
    btn1: "Indagar",
    title5: "Tasa de éxito regional de carga de punto de carga de CA y CC",
    title6: "Tasa de carga de diferentes versiones de firmware",
    title7: "Razones para el conector de salto de punto de carga CA y CC",
    title8: "Tasa de éxito de carga del canal TOP50",
  },
  citySuccessRate: {
    title1: "Rango",
    title2: "Zona",
    title3: "Número de pedido",
    title4: "En total",
    msg1: "Corriente alterna",
    msg2: "Corriente continua",
    msg3: "Todos",
    title5: "Número de pedidos exitosos",
    title6: "Número de pedidos fallidos",
    title7: "Tasa de éxito",
    tool1: "Tasa de éxito = Pedido de carga exitosa / pedido de carga total",
    title8: "Total",
    title9: "Número de pedidos exitosos",
    title10: "Número de pedidos fallidos",
    title11: "Tasa de éxito de carga",
    title12: "Número de pedido",
    title13: "Tasa de éxito",
    title14: "Número de pedidos exitosos",
    title15: "Número de pedidos fallidos",
    title16: "Tasa de éxito de carga",
    btn1: "Figura",
    btn2: "Tabla",
    wz1: "Detalles del pedido",
  },
  endCodeSuccessRate: {
    title1: "Motivo para detenerse",
    title2: "Pedido anormalmente fallida",
    title3: "Proporción",
    title4: "Lista de pedido",
    wz1: "Detalles del pedido",
  },
  versionTypeSuccessRate: {
    title1: "Versión",
    title2: "Número de pedido",
    msg1: "Corriente alterna",
    msg2: "Corriente continua",
    msg3: "Total",
    title3: "Número de pedidos exitosos",
    title4: "Número de pedidos fallidos",
    title5: "Tasa de éxito",
    tool1: "Tasa de éxito = pedido de carga exitosa / pedido de carga total",
    all: "En total",
    type1: "GBT 2011",
    type2: "GBT 2015 2.0",
    type3: "GBT 2015 2.1",
    type4: "Versión beta que \n comienza con 9",
    msg4: "Incógnita",
    title6: "Número de pedidos exitosos",
    title7: "Número de pedidos fallidos",
    title8: "Tasa de éxito de carga",
    title9: "Número de pedido",
    title10: "Tasa de éxito",
    title11: "Número de pedidos exitosos",
    title12: "Número de pedidos fallidos",
    title13: "Tasa de éxito de carga",
    btn1: "Figura",
    btn2: "Tabla",
    wz1: "Detalles del pedido",
  },
  stubDate: {
    title1: "Fecha",
    title2: "Tiempo de operación promedio",
    tool1:
      "Tiempo de operación: Tiempo de inactividad(Incluyendo el tiempo inactivo de inserción del conector)+Tiempo de carga+Tiempo de aparcamiento+Duración de la falla+Tiempo fuera de línea+Tiempo de la actualización+Tiempo de cita en espera de carga+Duración del almacenamiento de energía+Duración de la cita en línea.+Tiempo de carga completo;",
    tool1_2: "Tiempo de operación promedio:El tiempo de funcionamiento promedio de todos los equipos estadísticos.",
    title3: "Puntos de carga de fallos",
    title4: "Tiempo medio al fracaso",
    tool2:
      "Duración de la falla:El período de tiempo desde que el dispositivo cambia a un estado de falla hasta que el dispositivo cambia a otro estado.",
    tool2_2: "Tiempo medio al fracaso: El tiempo promedio de falla de todos los dispositivos con fallas.",
    title5: "Tasa de averías",
    tool3: "Tasa de averías=Duración de la falla/Tiempo de operación",
    title6: "Punto de carga fuera de línea",
    title7: "Tiempo promedio sin conexión",
    tool4:
      "Tiempo fuera de línea:El tiempo cuando el dispositivo cambia al estado fuera de línea comienza a contar hasta que el dispositivo cambia a otro estado.",
    tool4_2: "Tiempo promedio sin conexión:El tiempo de falla promedio de todos los dispositivos fuera de línea.",
    title8: "Tasa fuera de línea",
    tool5: "Tasa fuera de línea=Tiempo fuera de línea/Tiempo de operación",
    title9: "Tiempo intacto promedio",
    tool6: "Tiempo intacto=Tiempo de operación-Duración de la falla-Tiempo promedio",
    tool6_2: "Tiempo intacto promedio:La duración intacta promedio de todo el equipo estadístico.",
    tool7: "Tasa intacta=(Tiempo de operación-Tiempo fuera de línea-Duración de la falla)/Tiempo de operación",
    dw: "Día",
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo",
    totle: "En total",
    title10: "Tasa intacta",
    title11: "Tasa fuera de línea",
    title12: "Tasa de averías",
    data: "Fecha",
    btn: "Lista de dispositivos",
  },
  stubDetail: {
    state1: "Avería",
    state2: "Desconectado",
    btn1: "Consulta rápida de equipos",
    btn2: "Exportar",
    title1: "ID del dispositivo",
    title2: "La estación eléctrica pertenecia",
    title3: "Tipo de equipo",
    type1: "Corriente alterna",
    type2: "Corriente continua",
    type3: "CA/CC",
    type4: "Incógnita",
    title4: "Tipo de operación",
    operationMode1: "Operación de terceros",
    operationMode2: "Operación conjunta",
    operationMode3: "Operación direcata de Star Charge",
    operationMode4: "Franquicia",
    operationMode5: "Interconexión",
    operationMode6: "Estación eléctrica Renren",
    operationMode7: "Incógnita",
    title5: "Modelo de dispositivo",
    title6: "Modelo de firmware",
    title7: "Versión de firmware",
    title8: "Duración",
    title9: "Frecuencia",
    title10: "La última vez",
    title11: "Tiempo",
    title12: "Zona",
    dw: "Día",
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo",
  },
  stubIntact: {
    placeholder1: "Seleccione un rango de fechas",
    title1: "Fecha",
    placeholder2: "Seleccione la Zona",
    title2: "Zona",
    no: "No",
    yes: "Sí",
    msg1: "Mostrar subordinados",
    operationMode1: "Todos",
    operationMode2: "Operación de terceros",
    operationMode3: "Operación conjunta",
    operationMode4: "Operación direcata de Star Charge",
    operationMode5: "Franquicia",
    operationMode6: "Interconexión",
    operationMode7: "Estación eléctrica Renren",
    placeholder3: "Seleccione",
    title3: "Tipo de operación",
    type0: "Todos",
    type1: "Corriente alterna",
    type2: "Corriente continua",
    placeholder4: "Seleccione",
    title4: "Ordenar",
    areaFirst: "Indagar",
    operationFirst: "Presente por fecha",
    placeholder5: "Presente por categoría",
    title5: "Tipo de equipo",
    btn1: "Indagar",
    title6: "Presente por fecha",
    title7: "Presente por categoría",
    wz1: "Desglose regional", // 自翻
  },
  stubType: {
    title1: "Tipo de equipo",
    title2: "Tiempo de operación promedio",
    tool1:
      "Tiempo de operación: Tiempo de inactividad(Incluyendo el tiempo inactivo de inserción del conector)+Tiempo de carga+Tiempo de aparcamiento+Duración de la falla+Tiempo fuera de línea+Tiempo de la actualización+Tiempo de cita en espera de carga+Duración del almacenamiento de energía+Duración de la cita en línea.+Tiempo de carga completo;",
    tool1_2: "Tiempo de operación promedio:El tiempo de funcionamiento promedio de todos los equipos estadísticos.",
    title3: "Puntos de carga de fallos",
    tool2:
      "Duración de la falla:El período de tiempo desde que el dispositivo cambia a un estado de falla hasta que el dispositivo cambia a otro estado.",
    tool2_2: "Tiempo medio al fracaso: El tiempo promedio de falla de todos los dispositivos con fallas.",
    title4: "Tiempo medio al fracaso",
    title5: "Tasa de averías",
    tool3: "Tasa de averías=Duración de la falla/Tiempo de operación",
    title6: "Punto de carga fuera de línea",
    title7: "Tiempo promedio sin conexión",
    tool4:
      "Tiempo fuera de línea:El tiempo cuando el dispositivo cambia al estado fuera de línea comienza a contar hasta que el dispositivo cambia a otro estado.",
    tool4_2: "Tiempo promedio sin conexión:El tiempo de falla promedio de todos los dispositivos fuera de línea.",
    title8: "Tasa fuera de línea",
    tool5: "Tasa fuera de línea=Tiempo fuera de línea/Tiempo de operación",
    title9: "Tiempo intacto promedio",
    tool6: "Tiempo intacto=Tiempo de operación-Duración de la falla-Tiempo promedio",
    tool6_2: "Tiempo intacto promedio:La duración intacta promedio de todo el equipo estadístico.",
    title10: "Tiempo intacto promedio",
    title11: "Tasa intacta",
    tool7: "Tasa intacta=(Tiempo de operación-Tiempo fuera de línea-Duración de la falla)/Tiempo de operación",
    title12: "Lista de dispositivos",
    title13: "Zona",
    title14: "Tipo de operación",
    dw: "Día",
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo",
  },
  equipmentIntact: {
    placeholder1: "Seleccione una fecha",
    title1: "Fecha",
    placeholder2: "Seleccione una fecha",
    btn1: "Indagar",
    btn2: "Exportar los datos",
    title2: "Tipo de operación",
    operationMode1: "Operación de terceros",
    operationMode2: "Operación conjunta",
    operationMode3: "Operación direcata de Star Charge",
    operationMode4: "Franquicia",
    operationMode5: "Interconexión",
    operationMode6: "Estación eléctrica Renren",
    operationMode7: "Incógnita",
    title3: "Los puntos de carga en total",
    type1: "Corriente alterna",
    type2: "Corriente continua",
    totle: "En total",
    title4: "Punto de carga en construcción",
    title5: "Punto de carga ha sido construido",
    title6: "Punto de carga en manteniendo",
    title7: "Punto de carga disponible",
    title8: "Disponibilidad",
    title9: "Punto de carga de operación normal",
    title10: "Tasa intacta",
    title11: "Punto de carga sin política de valor operativo",
    title12: "Tasa intacta(Excluyendo puntos de carga de políticas)",
    title13: "Análisis de tipos de operación de puntos de carga",
  },
  crcExceptionList: {
    placeholder1: "Ingrese el número de terminal",
    title1: "ID del dispositivo",
    placeholder: "Seleccione",
    title2: "Modelo de dispositivo",
    title3: "Consulta de firmware",
    type0: "Todos",
    type1: "Corriente alterna",
    type2: "Corriente continua",
    type3: "CA/CC",
    title4: "Tipo de equipo",
    btn1: "Indagar",
    btn2: "Usar configuración de plataforma en lotes",
    btn3: "Usar la configuración del dispositivo en lotes",
    title5: "ID del dispositivo",
    title6: "Plataforma CRC",
    title7: "Dispositivo CRC",
    title8: "Tipo de equipo",
    title9: "Corriente alterna",
    title10: "Corriente continua",
    title11: "CA/CC",
    result1: "Incógnita",
    title12: "Modelo de dispositivo",
    title13: "Información del firmware",
    action: "Operación",
    btn4: "Ver la configuración",
    btn5: "Usar configuración de plataforma",
    btn6: "Usar configuración del dispositivo",
    msg1: "Operación exitosa",
    msg2: "Seleccione al menos uno",
    msg3: "Hasta máximo 100 lotes",
    msg5: "Información de configuración",
  },
  addEquipment: {
    msg1: "Seleccione al menos una estación eléctrica",
    msg2: "La estación eléctrica seleccionada ya existe",
    msg3: "Agregado exitosamente",
    msg4: "Seleccione al menos una estación eléctrica",
    msg5: "La estación eléctrica seleccionada no se agrega o se ha eliminado",
    msg6: "Eliminado con éxito",
    msg7: "Seleccione al menos una estación eléctrica",
    msg8: "Aplicación exitosa",
    msg9: "Agregar el conector",
    bnt1: "Eliminar estación eléctrica",
    msg10: "Muestra hasta 100 estaciones eléctricas",
  },
  cfgChangeTaskBuild: {
    btn1: "Subir configuración",
    msg1: "El contenido de la configuración no puede estar vacío",
    msg2: "Operación exitosa",
    msg3: "Subido correctamente",
    btn2: "Volver a subir",
    title1: "Nombre de la misión",
    title2: "Archivo de configuración subido",
    title3: "Contenido de la configuración",
    title4: "Resultado de la verificación",
    title5: "La verificación es correcta",
    title6: "La configuración del artículo es anormal",
    btn5: "Descarga de configuración",
    btn3: "Confirmar",
    btn4: "Cancelar",
    title7: "Nota",
  },
  cfgExport: {
    placeholder1: "Seleccione el número de conector y el elemento de configuración",
    title1: "Alcance de la misión",
    title2: "Opciones de configuración",
    placeholder: "Seleccione",
    btn1: "Exportación de configuración",
    btn2: "Cancelar",
    btn3: "Agregar",
  },
  equipmentListModal: {
    btn1: "Seleccione actual",
    btn2: "Agregar a granel",
    placeholder1: "Seleccione la Zona",
    title1: "Zona",
    title2: "Nombre de la estación eléctrica",
    btn3: "Indagar",
    title3: "Número de conector",
    title4: "Zona",
    title5: "Nombre de la estación eléctrica",
    btn5: "Operación",
    btn4: "Agregar",
    msg1: "No se puede consultar por provincia",
    title6: "Consulta de la estación eléctrica",
    btn6: "cover",
  },
  equipmentListModalDel: {
    title1: "Zona",
    placeholder1: "Seleccione la Zona",
    placeholder: "Seleccione",
    all: "Todos",
    type1: "Operación propia",
    type2: "No operación propia",
    title2: "Tipo de operación",
    title3: "Nombre de la estación eléctrica",
    btn1: "Indagar",
    btn2: "Cancelar",
    btn3: "Consulta de la estación eléctrica",
    action: "Operación",
  },
  stationListModal: {
    select: "Seleccionar todo / no seleccionar",
    btn1: "Seleccione actual",
    btn2: "Agregar a granel",
    title1: "Zona",
    placeholder1: "Seleccione la Zona",
    title2: "Nombre de la estación eléctrica",
    btn3: "Indagar",
    title8: "Zona",
    placeholder2: "Seleccione la Zona",
    title3: "Nombre de la estación eléctrica",
    btn4: "Indagar",
    title4: "Número de conector",
    title5: "Zona",
    title6: "Nombre de la estación eléctrica",
    btn5: "Operación",
    btn6: "Agregar",
    title7: "Consulta de la estación eléctrica",
  },
  taskExecuteResult: {
    title1: "ID del dispositivo",
    msg1: "Éxito",
    msg2: "Error al modificar la configuración de la plataforma",
    msg3: "Entrega de configuración fallida",
  },
  taskManagement: {
    placeholder1: "Ingrese el operador",
    title1: "Creador",
    all: "Todos",
    btn1: "Modificación de la configuración",
    btn2: "Actualización de firmware",
    placeholder: "Seleccione",
    title11: "Tipo de misión",
    state1: "No realizado",
    state2: "Ha sido ejecutado",
    title2: "Estado de la tarea",
    placeholder2: "Seleccione un rango de fechas",
    title3: "Tiempo de creación",
    btn3: "Indagar",
    btn4: "Crear una tarea nueva",
    btn5: "Exportación de configuración",
    actionSheet: "Nombre de la operación",
    title4: "Creador",
    title5: "Tiempo de creación",
    title6: "Tipo de misión",
    btn6: "Modificación de la configuración",
    btn7: "Actualización de firmware",
    title7: "Número de puntos de cargas en funcionamiento",
    title8: "Estado de la tarea",
    state3: "No realizado",
    title10: "Resultados de la ejecución",
    title9: "Nota",
    action: "Operación",
    btn8: "Ejecución de la tarea",
    msg1: "Operación exitosa",
    btn9: "Ver tareas",
    btn10: "Eliminar",
    msg2: "Operación exitosa",
    btn11: "Selección de tareas",
    btn12: "Exportación de configuración",
    btn13: "Ver tareas",
    btn14: "Detalles de resultados",
  },
  taskSelect: {
    placeholder1: "Seleccione el tipo de tarea a realizar",
    btn1: "Modificación de la configuración",
    btn2: "Crear tarea",
    modaltitle1: "Crear una tarea nueva",
  },
  account: {
    msg1: "Sin datos",
    btn1: "Agregar usuario",
    btn2: "Asignación de carácter",
    title1: "Gestión de usuarios",
    title2: "Lista de usuarios",
    title3: "Nombre de usuario",
    title4: "Teléfono del usuario",
    title5: "Buzón de usuario",
    action: "Operación",
    btn3: "Asignación de carácter",
    placeholder1: "Ingrese el nombre de usuario",
    title6: "Nombre de usuario",
    btn4: "Indagar",
    btn5: "Agregar usuario",
    wz1: "La cuenta",
  },
  addAccountModal: {
    placeholder1: "Compruebe el nombre de usuario primero",
    title1: "Nombre de usuario",
    btn1: "Indagar",
    title2: "Teléfono",
    title3: "Buzón",
    action: "Operación",
    btn2: "Agregar",
    msg1: "Agregado exitosamente",
  },
  dispatchRoleModal: {
    title1: "Todos los carácteres",
    title2: "Carácter seleccionado",
    placeholder1: "Ingrese contenido de búsqueda",
    msg1: "Sin opciones",
    dw1: "ítem",
    btn1: "Confirmar",
    btn2: "Vaciar",
  },
  dispatchPermissionsModal: {
    title1: "Nombre del permiso",
    placeholder1: "Ingrese el nombre del permiso",
    title2: "Permisos no seleccionados",
    title3: "Permisos seleccionados",
    placeholder2: "Busque",
    msg1: "Sin opciones",
    dw1: "Artículo",
    btn1: "Confirmar",
    btn2: "Vaciar",
    title4: "Nombre del permiso",
    placeholder3: "Ingrese el nombre del permiso",
    placeholder4: "Busque",
  },
  permissionList: {
    title1: "Configuraciones de permisos",
    title2: "Permiso de lectura del menú",
    title3: "Permiso de asignación de menú",
    title4: "Permiso de consulta de Zona de datos",
    title5: "Nombre del permiso",
    placeholder1: "Ingrese el nombre del permiso",
    btn1: "Indagar",
    btn2: "Agregar permisos",
    title6: "Nombre del permiso",
    action: "Operación",
    btn3: "Editar permisos",
    btn4: "Eliminar",
  },
  editRoleModal: {
    title1: "Nombre de carácter",
    placeholder1: "Ingrese el nombre de carácter",
    choose1: "Todos los permisos",
    choose2: "Permisos seleccionados",
    placeholder2: "Ingrese contenido de búsqueda",
    msg1: "Sin opciones",
    dw1: "ítem",
    btn1: "Confirmar",
    title2: "Nombre de carácter",
    placeholder3: "Ingrese el nombre de carácter",
  },
  role: {
    title1: "Configuración de carácteres",
    title2: "Nombre de carácter",
    action: "Operación",
    btn1: "Editar carácter",
    btn2: "Eliminar",
    btn3: "Agregar un carácter nuevo",
  },
  roleList: {
    title1: "Configuración de carácteres",
    title2: "Nombre de carácter",
    placeholder1: "Ingrese el nombre de carácter",
    btn1: "Indagar",
    btn2: "Agregar un carácter nuevo",
    title3: "Nombre de carácter",
    title4: "Estado",
    state1: "Normal",
    state2: "Inhabilitar",
    action: "Operación",
    btn3: "Editar carácter",
    btn4: "Eliminar",
  },
  no_access: {
    msg1: "No tienes acceso en este momento!",
    msg2: "Luego regrese automáticamente a la página de inicio de sesión.",
    btn1: "Volver arriba",
  },
  no_connect: {
    msg3: "Falla del servidor o interfaz",
  },
  no_menu: {
    msg1:
      "No tiene permisos de menú por un tiempo o el inicio de sesión ha expirado, comuníquese con el administrador para agregar permiso",
    msg2: "La página de inicio de sesión está a punto de saltar",
    wz1: "Salto inmediato", // 机翻译
  },
  nofound: {
    msg1: "La página que visitó no existe, ¡Intente nuevamente!",
  },
  formCore: {
    msg1: "Sin opciones",
    msg2: "Solicitud de interfaz fallida",
    msg3: "Form横向布局请勿使用穿梭框",
    msg4: "La longitud del contenido debe estar entre",
    msg4_2: "y",
    msg4_3: "",
    msg5: "El valor debe ser ≥",
    msg5_2: "0",
    msg5_3: "≤",
    msg6: "El número de decimales debe ser ≤",
    msg7: "Ingrese el valor correcto",
    msg8: "Ingrese un número positivo",
    msg9: "El valor debe ser un entero positivo ≥",
    msg9_2: ", o ≤",
    msg9_3: "",
    msg10: "Ingrese un entero positivo",
    msg11: "Ingrese un entero positivo distinto de cero",
    msg12: "El número de teléfono es incorrecto",
    msg13: "Marcar",
    msg14: "Verificar",
    msg15: "No se puede consulta a través de los años.",
    msg16: "Elige hasta",
    msg19: "días",
    msg17: "Elige al menos",
    msg18: "Verificar la fecha",
    placeholder1: "Ingrese el contenido",
    all: "Todos",
  },
  gridTableCore: {
    msg1: "Total",
    msg1_2: "",
    msg2: "Ninguno",
    msg3: "Vista previa de la imagen",
    msg4: "Estás seguro",
    msg4_2: "",
    btn1: "Confirmar",
    btn2: "Cancelar",
    btn3: "Más",
    msg5: "Error al construir la tabla",
    msg6: "Tabla en construiendo",
    wz1: "Sin datos provisionales", // 机翻译
  },
  scLayoutTab: {
    msg1: "Cierre las ventanas innecesarias!",
    btn1: "Cerrar sesión de usuario",
    web1: "Google",
    web2: "",
    webc: "Navegador recomendado:",
    msg2: "Número de versión",
    company: "Compañía Wanbang equipo de carga,S.L.",
    title1: "Modificar contraseña",
    lan1: "Chino.", // 机翻译
    lan2: "En inglés", // 机翻译
    lan3: "Eespañol", // 机翻译
    wz1: "Cambiar la contraseña",
  },
  fetchHandler: {
    msg1: "No existe tal categoría",
    msg2: "No se encontró una regla de cobro de marcador de aparcamiento para el grupo de punto de carga",
  },
  moduleList: {
    state1: "Todos",
    state2: "Normal",
    state3: "falla",
    placeholder1: "Ingrese el número del módulo", // 自翻
    placeholder2: "Ingrese el número del ID del dispositivo",
    title1: "ID del dispositivo",
    placeholder3: "Seleccione",
    title2: "número del módulo",
    title3: "ID del dispositivo",
    title4: "La marca", // 机器
    title5: "Tipo de módulo",
    value1: "kw salida", // 机器
    value2: "kw De alta presión", // 机器
    action: "Operación",
    modalTitle1: "Equipamiento histórico", // 机器
    brand1: "Delta",
    brand2: "Star Charge",
    brand3: "ZTE",
    btn1: "Indagar",
    dw: "Día",
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo",
    wz1: "Información de falla",
    wz2: "Duración de la operación",
    wz3: "Registro de fallos", // 机器
  },
  moduleInfo: {
    placeholder1: "Seleccione un rango de fechas",
    title1: "Fecha",
    btn1: "Indagar",
  },
  historyStubInfo: {
    placeholder1: "Ingrese el ID del dispositivo",
    title1: "ID del dispositivo",
    title2: "Duración de la operación", // 机器
    btn1: "Indagar",
    dw: "Día",
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo",
    wz1: "En total",
    wz2: "Información sobre los módulos",
  },
  eventMonitoring: {
    // 全部机器翻译
    placeholder1: "Ingrese el Nombre del evento",
    placeholder2: "Ingrese el Número del cuerpo",
    title1: "Número del cuerpo",
    placeholder3: "Seleccione la Zona",
    title2: "Zona",
    placeholder4: "Seleccione",
    title3: "Grado de operación y mantenimiento",
    operationMode1: "Todos",
    operationMode2: "Operación de terceros",
    operationMode3: "Operación conjunta",
    operationMode4: "Operación direcata de Star Charge",
    operationMode5: "Franquicia",
    operationMode6: "Interconexión",
    operationMode7: "Estación eléctrica Renren",
    placeholder: "Seleccione",
    title4: "Tipo de operación",
    placeholder5: "Seleccione un rango de fechas ",
    title5: "Fecha",
    title6: "Indagar",
    title7: "Nombre del evento",
    title8: "Cuerpo del evento",
    title9: "Número del cuerpo",
    title10: "ID del dispositivo",
    title11: "Grado de operación y mantenimiento",
    title12: "El número de",
    title13: "Hora de presentación",
    title14: "Nombre de la estación eléctrica",
    title15: "Zona",
    title16: "Tipo de operación",
    title17: "Modelo de dispositivo",
    title18: "Detalles",
    action: "Operación",
    btn1: "Datos de los módulos",
    wz1: "Módulo de alimentación",
    wz2: "Información sobre los módulos",
    all: "Todos",
  },
  faultReportingList: {
    placeholder1: "Ingrese el Nombre del fallo",
    title1: "Nombre del fallo",
    placeholder2: "Ingrese el ID del dispositivo",
    title2: "ID del dispositivo",
    placeholder3: "Seleccione la Zona ",
    title3: "Zona",
    placeholder: "Seleccione",
    title4: "Grado de operación y mantenimiento",
    title5: "Tipo de operación",
    placeholder4: "Seleccione un rango de fechas",
    title6: "Fecha",
    btn1: "Indagar",
    title7: "ID del dispositivo",
    title8: "Código de fallo",
    title9: "Nombre del fallo",
    title10: "Grado de operación y mantenimiento",
    title11: "Frecuencia",
    title12: "Última hora de presentación",
    title13: "Nombre de la estación eléctrica",
    title14: "Zona",
    title15: "Tipo de operación",
    title16: "Tipo de operación",
    title17: "Modelo de firmware",
    operationMode1: "Todos",
    operationMode2: "Operación de terceros",
    operationMode3: "Operación conjunta",
    operationMode4: "Operación directa Star Charge",
    operationMode5: "Operación franquicia",
    operationMode6: "Interconexión",
    operationMode7: "Estación eléctrica Renren",
    all: "Todos",
  },
  exportBtn: {
    msg1: "No hay datos",
    placeholder1: "Seleccione las condiciones de consulta",
    btn1: "Exportar",
  },
  publicParam: {
    all: "Todos",
    type1: "StarCharge-APP",
    type2: "StarCharge-SAAS",
    type3: "SAAS-StarChargeAccount",
    type4: " ",
    btn1: "selección",
    btn2: "determinar",
    btn3: "restaurar",
    msg1: "Sin datos provisionales",
  },
  TreeTransfer: {
    wz1: "datos",
    wz2: "introduzca la palabra clave",
    wz3: "Datos fuente",
    wz4: "Datos de finalidad",
  },
  login3: {
    lan1: "Chino.", // 机翻译
    lan2: "En inglés", // 机翻译
    lan3: "Eespañol", // 机翻译
    wz1: "Sistema de gestión de operaciones y mantenimiento",
  },
  LoginEnterAccount: {
    wz1: "Ingrese el La cuenta",
    wz2: "inicio",
  },
  AccountLogin: {
    wz1: "La contraseña no debe estar en blanco",
    wz2: "introduzca el código de verificación correcto",
    wz3: "Por favor, introduzca su contraseña",
    wz4: "Por favor, introduzca el código de verificación",
    wz5: "inicio",
    wz6: "inicio",
  },
  addAccountModalIntel: {
    wz1: "La cuenta debe ser UN número de correo electrónico o de teléfono móvil",
    wz2: "Número de cuenta y nombre de usuario obligatorio",
    wz3: "Los nuevos usuarios han sido añadidos con éxito. configure los derechos de usuario",
    wz4: "Los nombres",
    wz5: "Por favor, introduzca el nombre del usuario",
    wz6: "La cuenta",
    wz7: "Ingrese el inicio ",
    wz8: "Introduzca su número de cuenta (correo electrónico/teléfono móvil)",
    wz9: "Presentación",
  },
  ChangePassword: {
    wz1: "La contraseña original no debe estar en blanco",
    wz2: "Por favor, introduzca una nueva contraseña",
    wz3: "Por favor, introduzca la contraseña de confirmación",
    wz4: "Las dos entradas de contraseña no coinciden",
    wz5: "Éxito en la modificación de la contraseña",
    wz6: "Código original",
    wz7: "Ingrese el Código original",
    wz8: "Nueva contraseña",
    wz9: "Ingrese el Nueva contraseña",
    wz10: "Confirmar la contraseña",
    wz11: "Por favor, confirme su contraseña",
    wz12: "Presentación",
  },
  scModal: {
    text1: "Confirmar",
    text2: "Cancelar",
  },
};



// WEBPACK FOOTER //
// ./src/AntD/locale/es-ES.messages.js